<template>
	<div class="wrap">
		<div class="story-title">
			公司简介
			<div class="story-title-line"></div>
		</div>
		<div class="wrap-article">
			<div class="article-li">
				丁震医学教育（北京丁丁颐和科技有限公司，广州丁丁舜思教育科技有限公司，北京丁丁颐和科技有限公司沈阳分公司www.dzyxedu.com）是专业化的医学考试图书策划及教育培训机构，以专业的教学团队、丰富的教育资源及卓越的培训成果，在全国范围内赢得了广泛的认可和赞誉，成为在医学考试培训领域具有较高知名度的教育品牌，旨在为全国医院和护理院校的考生提供高质量的原创考试图书和培训课程，促进我国医学教育和应考水平的提升。
			</div>
		</div>
		<div class="wrap-img">
			<div class="animated animate__bounceInLeft img-li">
				<img src="https://test.dzyxedu.com/homeImage/brandStoryImage4.png" alt="" />
			</div>
			<div class="animated animate__bounceInUp img-li">
				<img src="https://test.dzyxedu.com/homeImage/brandStoryImage5.png" alt="" />
			</div>
			<div class="animated animate__bounceInRight img-li">
				<img src="https://test.dzyxedu.com/homeImage/brandStoryImage6.png" alt="" />
			</div>
		</div>
		<div class="story-title">
			创始人简介
			<div class="story-title-line"></div>
		</div>
		<div class="wrap-content">
			<div class="animated animate__flipInX content-img" style="width: 500px;">
				<img src="https://test.dzyxedu.com/homeImage/brandStoryImage1.png" alt="" />
			</div>
			<div class="wrap-article content-right">
				<div class="article-li article-li-line">
					丁震老师是国内少有的既懂出版又能讲护理考试课的跨界型专家，原人民军医出版社考试中心主任，曾是风靡全国的“军医版”医学考试书籍的策划人和编著者。从事医学考试图书策划近20年，对考试命题方向和细节把握精准，原创“点线学习法”培训体系，并在全国护理院校进行广泛的推广和应用。2016年从部队转业后创办“丁震医学教育”，凭借其深厚的学术背景、丰富的实践经验和卓越的领导能力，成功打造了以原创性的图书和培训课程研发为根本的专业化医学考试图书策划及教育培训机构。
				</div>
			</div>
		</div>
		<div class="story-title">
			图书介绍
			<div class="story-title-line"></div>
		</div>
		<div class="wrap-content">
			<div class="wrap-article content-right">
				<div class="article-li article-li-line">
					2019年起至今，丁震老师策划、编著全国护士执业资格考试及卫生专业技术资格（中初级）考试图书累计129本。护理考试代表作有《丁震急救包》系列、《丁震点线学习法十年考点总结》系列及《丁震点线学习法十年试题解析》系列、《丁震模拟6套卷全解析》系列、《丁震考前预测5套卷全解析》系列、《丁震考前冲刺必做4套卷》系列、《丁震考前必背掌中宝》系列、《丁震札记》系列、《丁震历年真题考点解读5套卷》、护理学（师）和护理学（中级）《丁震单科考点背诵及强化1000题》系列等。卫生专业技术资格考试代表作有《应试指导及历年考点串讲》系列、《模拟试卷及解析》系列。
				</div>
				<div class="article-li article-li-line">
					根据考试变化，丁震医学教育团队始终坚持及时修订和内容原创的原则，每年增补新的知识总结和新试题。丁震医学教育系列资料出版近20年来，命中率高，考生口碑好，全国累计销量2000万册，助力数千万考生通过考试。
				</div>
			</div>
			<div class="animated animate__rotateInDownRight content-img content-img-other">
				<img src="https://test.dzyxedu.com/homeImage/brandStoryImage7.png" alt="" />
			</div>
		</div>
		<div class="story-title">
			课程介绍
			<div class="story-title-line"></div>
		</div>
		<div class="wrap-article">
			<div class="article-li">
				丁震老师对全国护士执业资格考试、卫生专业技术资格考试有深入研究，独创“点线学习法”培训体系，2010年以来，在全国护理院校现场巡讲200余场，举办40余场护考师资交流培训会。
			</div>
			<div class="article-li">
				2019年，丁震医学教育的护理考试培训课程上线，由丁震领衔，邀请全国部分护理院校的资深讲师共同授课，为参加全国护士执业资格考试、护理学（师）和护理学（中级）考试的考生提供“丁震预测课”、“考点精讲课”、“丁震押题模考课”、“丁老师备考指导课”四大精品课程。
			</div>
			<div class="article-li">
				2021年，广州丁丁舜思教育科技有限公司成立，此后，丁震医学教育持续扩大精英团队，修订完善课程，覆盖更多考点，优化培训内容，
				增强考务服务，依托线上平台，开展系列直播，发布上千视频，进一步提升服务质量和市场竞争力。
			</div>
			<div class="article-li">
				2023年起将所有课程转变为录播形式，逐步增加更好理解的课程内容，如以讲题为主的“单科预测课”“单科押题课”“历年题讲解课”“病例分析专项课”，以讲知识点为主的核心专题课等，2025年课程继续升级，新增基础阶段课程“零基础精讲课”，“单科预测课”、“单科押题课”升级为“预测押题课”和“冲刺押题课”，课程讲解中对知识点的扩展是最大特色，特别有助于考生深刻理解每道题和每个知识点，融会贯通，举一反三。
			</div>
			<div class="article-li">
				在经典班型“基础精讲班”“考前冲刺班”“会员私塾班”的基础上，不断迭代完善成“1+1直通车”“全程精修班”“无忧畅听班”“VIP高端班”等班型，课程讲解更加精准，可助力考生，极大提高复习效率。
			</div>
		</div>
		<div class="wrap-banner">
			<el-image src="https://test.dzyxedu.com/homeImage/brandStoryImage8.png" fit="fill"></el-image>
		</div>
		<div class="story-title">
			服务生态
			<div class="story-title-line"></div>
		</div>
		<div class="wrap-info">
			<div class="info-li">
				<div class="info-li-left"></div>
				<div class="info-li-right">
					<div class="article-li">
						2019-2024年，丁震医学教育依托ATA（全美在线）平台，为考生提供线上课程及答题服务。
					</div>
					<div class="article-li">
						2024年，北京丁丁颐和科技有限公司沈阳分公司成立，着重强化丁震医学教育数字平台建设，致力于创造更好的服务体验，并逐步做到以下5个方面的创新：
					</div>
				</div>
			</div>
			<div class="info-li">
				<div class="info-li-left">
					<img src="https://test.dzyxedu.com/homeImage/%E4%B8%AA%E6%80%A7%E5%8C%96%E5%AD%A6%E4%B9%A0%E6%96%B9%E6%A1%88.png" alt="" />
				</div>
				<div class="info-li-right">
					<div class="li-right-title">个性化学习方案：</div>
					<div class="article-li">
						利用大数据和人工智能技术，精准分析考生学习习惯及能力水平，为考生量身定制学习计划和课程安排，提高学习效率。
					</div>
				</div>
			</div>
			<div class="info-li">
				<div class="info-li-left">
					<img src="https://test.dzyxedu.com/homeImage/%E6%99%BA%E8%83%BD%E8%AF%84%E4%BC%B0%E4%B8%8E%E5%8F%8D%E9%A6%88.png" alt="" />
				</div>
				<div class="info-li-right">
					<div class="li-right-title">智能评估与反馈：</div>
					<div class="article-li">
						根据考生答题数据，对考生的学习成果进行即时、全面评估，生成详细反馈报告，指出考生的强项弱项，提供针对性改进建议，明确备考方向，优化复习策略。
					</div>
				</div>
			</div>
			<div class="info-li">
				<div class="info-li-left">
					<img src="https://test.dzyxedu.com/homeImage/%E4%B8%B0%E5%AF%8C%E7%BA%BF%E4%B8%8A%E8%B5%84%E6%BA%90%E5%BA%93.png" alt="" />
				</div>
				<div class="info-li-right">
					<div class="li-right-title">丰富线上资源库：</div>
					<div class="article-li">
						提供更多线上学习资料、模拟试题、历年真题等资源，供考生低成本获取。
					</div>
				</div>
			</div>
			<div class="info-li">
				<div class="info-li-left">
					<img src="https://test.dzyxedu.com/homeImage/%E7%A4%BE%E7%BE%A4%E9%BC%93%E5%8A%B1%E4%B8%8E%E6%94%AF%E6%8C%81.png" alt="" />
				</div>
				<div class="info-li-right">
					<div class="li-right-title">社群鼓励与支持：</div>
					<div class="article-li">
						建立学习社群，鼓励考生之间分享学习心得、交流经验，形成良好的学习氛围和互助机制。
					</div>
				</div>
			</div>
			<div class="info-li">
				<div class="info-li-left">
					<img src="https://test.dzyxedu.com/homeImage/%E5%94%AE%E5%90%8E%E6%9C%8D%E5%8A%A1%E4%B8%8E%E8%BF%BD%E8%B8%AA.png" alt="" />
				</div>
				<div class="info-li-right">
					<div class="li-right-title">售后服务与追踪：</div>
					<div class="article-li">
						通过技术方式提供学习咨询、答疑解惑等后续服务，确保考生在学习的道路上始终有人相伴、有问必答，从而帮助考生提高备考体验并取得较好成果。
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'BrandStory',
		data() {
			return {};
		},
	};
</script>
<style scoped>
	.wrap {
		max-width: 1520px;
		margin: auto;
		margin-top: 8px;
		margin-bottom: 125px;
		background-color: #fff;
		padding: 68px 136px 47px 136px;
		box-sizing: border-box;
		border-radius: 15px;
	}
	.story-title {
		font-size: 28px;
		font-weight: 500;
		letter-spacing: 5px;
		line-height: 40.54px;
		color: rgba(0, 0, 0, 1);
		margin-bottom: 25px;
	}
	.story-title-line {
		margin-top: 6px;
		width: 296px;
		height: 5px;
		background: linear-gradient(90deg, rgba(255, 158, 116, 1) 0%, rgba(255, 255, 255, 0) 100%);
	}
	.wrap-article {
		width: 100%;
		font-size: 16px;
		font-weight: 400;
		line-height: 46px;
		color: rgba(66, 66, 66, 1);
	}
	.article-li {
		margin-bottom: 25px;
	}
	.wrap-img {
		display: flex;
		width: 100%;
		justify-content: space-between;
		margin-bottom: 86px;
	}
	.img-li {
		width: 396.97px;
		height: 227.63px;
		border-radius: 10px;
		overflow: hidden;
		transition: all linear 0.3s;
	}
	.img-li:hover {
		transform: scale(1.1);
	}
	.wrap-content {
		display: flex;
		margin-bottom: 39px;
	}
	.content-img {
		width: 577px;
		height: 313px;
		border-radius: 10px;
		margin-right: 48px;
		overflow: hidden;
	}
	.content-img-other {
		margin-right: 0px;
		margin-left: 41px;
		width: 602px;
		height: 429px;
	}
	.content-right {
		flex: 1;
	}
	.article-li-line {
		line-height: 36px;
	}
	.wrap-banner {
		width: 100%;
		height: 436px;
		border-radius: 10px;
		margin-bottom: 88px;
		overflow: hidden;
	}
	.wrap-info {
		width: 100%;
	}
	.info-li {
		display: flex;
		margin-bottom: 10px;
	}
	.info-li-left {
		width: 35px;
		height: 32px;
		overflow: hidden;
		margin-right: 27px;
		margin-top: 11px;
	}
	.info-li-right {
		flex: 1;
		font-size: 16px;
		font-weight: 400;
		line-height: 23.17px;
		color: rgba(66, 66, 66, 1);
	}
	.li-right-title {
		font-size: 22px;
		font-weight: 500;
		line-height: 46px;
		color: rgba(66, 66, 66, 1);
		margin-bottom: 10px;
	}
	.content-img img,
	.wrap-banner img,
	.img-li img,
	.info-li-left img {
		width: 100%;
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/views/brandStory/brandStory.vue